module.exports = __webpack_public_path__ + "img/p301.7b48595c.png";